import Scrollbar from 'smooth-scrollbar';
import {isMobile } from './exportFunc'
export default () =>{

    const pdfPopups = document.querySelectorAll('.popup-pdf');

    pdfPopups?pdfhandle():false;

    function pdfhandle(){
        pdfPopups.forEach(pdfPopup => {

        
            let scrollbar = Scrollbar.get(document.querySelector('.scroll-container'));
            const pdfFile = pdfPopup.dataset.pdfSource;
            const prevButton = pdfPopup.querySelector('[nav-prev]');
            const nextButton = pdfPopup.querySelector('[nav-next]');
            const curPage = pdfPopup.querySelector('[cur-page]');
            const zoomIn = pdfPopup.querySelector('[zoom-in]');
            const zoomOut = pdfPopup.querySelector('[zoom-out]');
            var numPages = 0;
            
            let myState = {
                pdf: null,
                currentPage: 1,
                zoom: 1
            }
        
            pdfjsLib.getDocument(pdfFile).then((pdf) => {
                myState.pdf = pdf;
                numPages = pdf.numPages;
                render();
            });
        
            function render() {
                myState.pdf.getPage(myState.currentPage).then((page) => {
            
                    var canvas = pdfPopup.querySelector("[pdf-renderer]");
                    var ctx = canvas.getContext('2d');
        
                    var viewport = page.getViewport(myState.zoom);                   
                    canvas.width = viewport.width;
                    canvas.height = viewport.height;
                    page.render({
                        canvasContext: ctx,
                        viewport: viewport
                    });
                });
                pdfPopup.querySelector('.all').innerHTML = addZero(myState.pdf.numPages);
                scrollbar.update();
            }
        
            prevButton.addEventListener('click', (e) => {
                if(myState.pdf == null || myState.currentPage == 1) 
                return;
                myState.currentPage -= 1;
                curPage.innerHTML = addZero(myState.currentPage);
                render();
            });
        
            nextButton.addEventListener('click', (e) => {
                if(myState.pdf == null || myState.currentPage >= myState.pdf.numPages) 
                return;
                myState.currentPage += 1;
                curPage.innerHTML = addZero(myState.currentPage);
                render();
            });

            function addZero(num){
                if( num < 10 ){
                    return ('0' + num).slice(-2)
                } else {
                    return num
                }
                
            }
            
            zoomIn.addEventListener('click', (e) => {
                
                if(myState.pdf == null) return;
                myState.zoom += 0.5;
                render(true);
            });
        
            zoomOut.addEventListener('click', (e) => {
                if(myState.pdf == null) return;
                myState.zoom -= 0.5;
                render();
            });

        })
    }
}
